$(document).ready(function (){
    $('.lazy-custom').lazy({
        beforeLoad: (element)=>{
            element.parent().find('.loader').css('z-index','1')
        },
        afterLoad: function(element) {
            element.parent().find('.loader').css({
                'z-index':'-1',
                "display":"none"
            })
        }
    })

    $('.lazy-banner-load').each((e,t)=>{
        if($(t).hasClass('mobile--banner') && window.innerWidth < 641){
            console.log('load')
            $(t).lazy()
        }else if (window.innerWidth >= 641 && $(t).hasClass('desktop--banner')){
            $(t).lazy()
        } else if ($(t).parent().find('.mobile--banner').length === 0 && window.innerWidth < 641){
            $(t).lazy()
        }
    })
    function handlePageDisplay(element) {
        if(window.innerWidth < 640){
            if(element.hasClass('desktop--banner')){
                element.css('display','none')
            }else if(element.hasClass('mobile--banner')){
                element.css('display','flex')
            }
        }else{
            if(element.hasClass('desktop--banner')){
                element.css('display','flex')
            }else if(element.hasClass('mobile--banner')){
                element.css('display','none')
            }
        }
        element.parent().find('.loader').css({
            'z-index':'-1',
            "display":"none"
        })
    }


})

/*$('.input-link').click((e)=>{
    e.preventDefault()
    $('#Search').attr('aria-hidden',false)
    $(document).addClass('no-scroll')
    $('#Search .Search__Input').focus()
    var onFocusListener = function onFocusListener() {
        document.getElementById('Search').removeEventListener('transitionend', onFocusListener);
    };

    document.getElementById('Search').addEventListener('transitionend', onFocusListener);

})*/

/*;(function () {
   if(window.theme.template === "index" && window.innerWidth < 650){
       const img = $('.img-block-box');
       img.each((dx,im)=>{
           console.log(im)
           let imgUrl = $(im).attr('data-src');
           imgUrl = imgUrl.toString()
           if (imgUrl.includes('1200x.')){
               imgUrl = imgUrl.replace('1200x','620x');
               im.attr('data-src', imgUrl)
           }
       })
   }
})()*/

$(document).on('collection:sort:loading:end',() => {
    $('.CollectionInner .lazy-custom').lazy({
        effect:'fadeIn',
        beforeLoad: (element)=>{
            element.parent().find('.loader').css('z-index','1')
        },
        afterLoad: function(element) {
            element.parent().find('.loader').css('z-index','-1')
        }
    })
});
$(document).on('theme:loading:search:end',() => {
    $('#Search .lazy-custom').lazy({
        effect:'fadeIn',
        beforeLoad: (element)=>{
            element.parent().find('.loader').css('z-index','1')
        },
        afterLoad: function(element) {
            element.parent().find('.loader').css('z-index','-1')
        }
    })

    $('.currency-switcher').trigger('change')
})
